import { render, staticRenderFns } from "./IconZelfgebruikAlgemeen.vue?vue&type=template&id=a2735bd6&scoped=true"
import script from "./IconZelfgebruikAlgemeen.vue?vue&type=script&lang=ts"
export * from "./IconZelfgebruikAlgemeen.vue?vue&type=script&lang=ts"
import style0 from "./IconZelfgebruikAlgemeen.vue?vue&type=style&index=0&id=a2735bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2735bd6",
  null
  
)

export default component.exports